import * as angular from 'angular';

import AptitudeMicroChartDirective from './aptitudeMicroChart.directive';
import { AptLoadingSpinnerComponent } from './aptLoadingSpinner.component';
import { AptRatingsComponent } from './aptRatings.component';
import { DiscontinuedBadgeComponent } from './discontinuedBadge.component';
import { EllipsisComponent } from './ellipsis.component';
import { FilterOptionsMenuComponent } from './filterOptionsMenu.component';
import { HighLowIndicatorComponent } from './highLowIndicator.component';
import { IsTruthyComponent } from './isTruthy.component';
import { MicroChartWithTiersModalService } from './microchartModal.service';
import { MicroChartWithTiersComponent } from './microChartWithTiers.component';
import { MiniGraphComponent } from './miniGraph.component';
import { NanoDonutComponent } from './nanoDonut.component';
import { RedirectToHomepageComponent } from './redirectToHomepage.component';
import SetIndeterminateStateDirective from './setIndeterminateState.directive';
import StarsHoverDirective from './starsHover.directive';
import { SummaryPanelComponent } from './summaryPanel.component';
import { SvgIconComponent } from './svgIcon.component';
import { AssessmentComponent } from './assessment.component';
import { AptAssessmentLiteComponent } from './aptAssessmentLite.component';
import { AptModalHeaderWithSearchComponent } from './aptModalHeaderWithSearch.component';
import { ProductCrossesDescriptionComponent } from './productCrossesDescription.component';
import { ProductCrossesGridComponent } from './productCrossesGrid.component';
import { MemberNavComponent } from './memberNav.component';
import { GroupNotificationsComponent } from './groupNotifications/groupNotifications.component';

// These are modules we use on every single page
export default angular
  .module('coreComponents', ['ngSanitize', 'ngAnimate', 'mgcrea.ngStrap'])
  .directive('aptitudeMicroChart', AptitudeMicroChartDirective)
  .component('aptLoadingSpinner', AptLoadingSpinnerComponent)
  .component('aptRatings', AptRatingsComponent)
  .directive('aptSetIndeterminateState', SetIndeterminateStateDirective)
  .component('discontinuedBadge', DiscontinuedBadgeComponent)
  .component('ellipsis', EllipsisComponent)
  .component('filterOptionsMenu', FilterOptionsMenuComponent)
  .component('coreHighLowIndicator', HighLowIndicatorComponent)
  .component('isTruthy', IsTruthyComponent)
  .component('memberNav', MemberNavComponent)
  .component('microChartWithTiers', MicroChartWithTiersComponent)
  .component('miniGraph', MiniGraphComponent)
  .component('nanoDonut', NanoDonutComponent)
  .component('redirectToHomepage', RedirectToHomepageComponent)
  .directive('starsHover', StarsHoverDirective)
  .component('summaryPanel', SummaryPanelComponent)
  .component('svgIcon', SvgIconComponent)
  .component('assessment', AssessmentComponent)
  .component('aptAssessmentLite', AptAssessmentLiteComponent)
  .component(
    'aptModalHeaderWithSearchComponent',
    AptModalHeaderWithSearchComponent
  )
  .component('productCrossesGridComponent', ProductCrossesGridComponent)
  .component(
    'productCrossesDescriptionComponent',
    ProductCrossesDescriptionComponent
  )
  .component('groupNotifications', GroupNotificationsComponent)
  .service('MicroChartWithTiersModal', MicroChartWithTiersModalService)
  .run(function ($templateCache) {
    'ngInject';

    $templateCache.put(
      'assessmentPopover',
      require(`./assessment.popover.html`)
    );
    $templateCache.put(
      'assessmentThumbsUpButtonPopover',
      require(`./assessmentThumbsUpButton.popover.html`)
    );
    $templateCache.put(
      'assessmentThumbsDownButtonPopover',
      require(`./assessmentThumbsDownButton.popover.html`)
    );
  }).name;
